module.exports = __webpack_public_path__ + "static/media/industry.f1e5c2ba.svg";